import { render, staticRenderFns } from "./Doop.vue?vue&type=template&id=4444707a&"
import script from "./Doop.vue?vue&type=script&lang=js&"
export * from "./Doop.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports